import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Popover, Card } from "@mui/material";
/**
 * @component  PopOverInput
 * @description Reusable input field component for form
 * @returns input field
 */
function PopOverInput(props) {
  const [showError, setShowError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // call when dependency get change
  useEffect(() => {
    setShowError(
      props.touched[props.fieldName] && props.fieldError[props.fieldName]
        ? true
        : false
    );
  }, [props.fieldError, props.fieldName, props.touched]);

  // function for open popover after field get validation error
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // function for close popover after field get solve validation error
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  // flag initialization for popover
  const open = Boolean(anchorEl);

  return (
    <div className="loginBoxFormControl">
      <label>
        <div className="loginBoxFormControl_label">
          {props.fieldLabel}{" "}
          {props.fieldRequired && <span className="inputFieldAsterisk">*</span>}{" "}
          {showError && (
            <span>
              <Popover
                id="mouse-over-popover"
                sx={{
                  pointerEvents: "none",
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                {props.fieldError[props.fieldName] ? (
                  <Card sx={{ p: 1 }}>
                    <span className="errorMsg">
                      {props.fieldError[props.fieldName]}
                    </span>
                  </Card>
                ) : null}
              </Popover>
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="infoIcon"
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              />
            </span>
          )}
          {props.children}
        </div>
      </label>
    </div>
  );
}

PopOverInput.propTypes = {
  fieldLabel: PropTypes.string,
  fieldName: PropTypes.string,
  fieldRequired: PropTypes.bool,
  fieldError: PropTypes.object,
  touched: PropTypes.object,
};

export default PopOverInput;
